package com.essntl.features.message.ui.group_info

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.isCtrlPressed
import androidx.compose.ui.input.key.isMetaPressed
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.dp
import com.essntl.features.message.ui.chat.ChatEvent
import com.essntl.features.message.ui.chat.ChatState
import com.essntl.uikit.components.chat.contact.ContactUiState.ContactType
import com.essntl.uikit.components.chat.group.EsGroupMemberCard
import com.essntl.uikit.components.chat.group.GroupAvatar
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun GroupInfoScreen(
    state: ChatState,
    onEvent: (ChatEvent) -> Unit,
) {
    val isLoading = remember(state) { state.isLoading }

    val isFailure = remember(state) { state.isFailure }

    var isDropDownExpanded by remember { mutableStateOf(false) }

    if (isLoading || isFailure)
        Box(
            contentAlignment = Alignment.TopCenter,
            modifier = Modifier.fillMaxSize(),
        ) {
            if (isLoading)
                EsSpinner()
            else
                Text(
                    text = "Something goes wrong!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                    modifier = Modifier.padding(start = 2.5f.spacing),
                )
        }
    else
        Column(
            verticalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier
                .fillMaxSize()
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(12.dp),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier
                    .fillMaxWidth()
                    .border(
                        width = 1.dp,
                        color = MaterialTheme.esColorScheme.borderPrimary,
                        shape = RoundedCornerShape(16.dp),
                    )
                    .padding(
                        horizontal = 12.dp,
                        vertical = 24.dp,
                    ),
            ) {
                GroupAvatar()

                Text(
                    text = state.getWhapiChat.data?.name ?: "",
                    style = MaterialTheme.esTypography.p1Bold16.copy(
                        color = MaterialTheme.esColorScheme.textPrimary,
                    ),
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = "Group members",
                style = MaterialTheme.esTypography.p2Medium14.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )

            state.getWhapiChat.data?.participants.orEmpty().map { participant ->
                val client = state.getClients.data.orEmpty().firstOrNull { it.telephone == participant.id }
                val supplier =
                    state.getAllSupplier.data.orEmpty().firstOrNull { it.contact?.phoneNumber == participant.id }
                val travelAgent =
                    state.getAllTravelAgent.data.orEmpty().firstOrNull { it.contact?.phoneNumber == participant.id }

                if (client == null && supplier == null && travelAgent == null) return@map

                val contactType =
                    if (client != null)
                        ContactType.Client
                    else if (supplier != null)
                        ContactType.Supplier
                    else if (travelAgent != null)
                        ContactType.TravelAgent
                    else null

                EsGroupMemberCard(
                    name = client?.prettyName ?: supplier?.contactName ?: travelAgent?.prettyName ?: "",
                    phoneNumber = participant.id,
                    type = contactType,
                    showCheckBox = false,
                    showOptionsIcon = true,
                    onClick = {
                        val groupId = state.getWhapiChat.data?.id ?: return@EsGroupMemberCard
                        onEvent(
                            ChatEvent.RemoveParticipantFromGroup(
                                groupId = groupId,
                                participants = participant.id,
                            ),
                        )
                    },
                )
            }
        }
}